var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.isMobile)?[_c('complianceDialog')]:[_c('mobileComplianceDialog')],_c('router-view')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }